require('./assets/styles/main.scss');
import { setup } from 'goober';
import { shouldForwardProp } from 'goober/should-forward-prop';
import useTheme from './styled/useTheme';
setup(React.createElement, undefined, useTheme, shouldForwardProp(function (prop) {
    // props that start with `$` symbol will not be forwarded to dom
    return prop['0'] !== '$';
}));
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
ReactDOM.render(React.createElement(App, null), document.getElementById('content'));
